import apiHandler from "../core/apiHandler";
const GoogleAuthenticatorApi = apiHandler('2fa');
export default GoogleAuthenticatorApi;
